import {useSelector} from 'react-redux';
import Selector from '../../../../../selectors/modals/wallet/methods/cashapp_p2p_deposit';

import Bitcoin from './bitcoin';
import Create from './create';
import Confirm from './confirm';
import Notice from './notice';
import Confirmed from './confirmed';

export default () => {
    const {stage} = useSelector(Selector);

    if(stage === 'bitcoin') return <Bitcoin />
    if(stage === 'create') return <Create />
    if(stage === 'notice') return <Notice />
    if(stage === 'confirm') return <Confirm />
    if(stage === 'confirmed') return <Confirmed /> 
    return <>{stage}</>;
}